import { render, staticRenderFns } from "./leftTree.vue?vue&type=template&id=676e2848&scoped=true"
import script from "./leftTree.vue?vue&type=script&lang=js"
export * from "./leftTree.vue?vue&type=script&lang=js"
import style0 from "./leftTree.vue?vue&type=style&index=0&id=676e2848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e2848",
  null
  
)

export default component.exports